import ValuationStepValidator from '@/interfaces/valuation/ValuationStepValidator'
import {
  ValuationStepData,
  LocalityValuationStepData,
} from '@/interfaces/valuation/ValuationData'
import {
  LocationType,
  isLocationObject,
} from '@/interfaces/valuation/types/LocalityValuationStep'
import { Message, MessageType } from '@/interfaces/app/Message'
import createMessage from '@/services/app/createMessage'
import store from '@/store'
import { BuildingType } from '@/interfaces/valuation/types/BuildingValuationStep'

export default class LocalityValuationStepValidator extends ValuationStepValidator {
  public isValid: boolean = false

  public validate(data: ValuationStepData): Message[] {
    const stepData = data as LocalityValuationStepData
    const errors: Message[] = []
    const buildingType = store.getters['valuationProcess/buildingType']

    if (
      buildingType !== BuildingType.New &&
      stepData.locationType === LocationType.Project
    ) {
      errors.push(
        createMessage(
          'Krok 3 - Lokality dle projektu lze vyhledávat pouze u novostaveb',
          MessageType.Error
        )
      )
    }

    if (!this.enumContains(LocationType, stepData.locationType)) {
      errors.push(
        createMessage(
          'Krok 3 - Nesprávně zvolený typ specifikace lokality',
          MessageType.Error
        )
      )
    }

    if (
      stepData.location === undefined ||
      !isLocationObject(stepData.locationType, stepData.location)
    ) {
      errors.push(
        createMessage('Krok 3 - Nevyplněná lokalita', MessageType.Error)
      )
    }

    if (errors.length === 0) {
      this.isValid = true
      return [createMessage('Krok 3 je vyplněný správně', MessageType.Success)]
    } else {
      this.isValid = false
      return errors
    }
  }
}
